import { Image, Text, View } from '@react-pdf/renderer';

import { getCommentaryTableHelperText } from '../../../redux/features/selectors/utils/getCommentaryTableHelperText.ts';
import { COMMENTARY_TEXT, PNG_HEIGHT, PNG_WIDTH } from '../../commentary/consts.ts';
import { ExportChartContainer } from '../../commentary/export/ExportChartContainer.tsx';
import { ExportCommentaryTable } from '../../commentary/export/ExportCommentaryTable.tsx';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { SiteExtractionAdjustmentsPageProps } from '../types.ts';

export const SiteExtractionAdjustmentsPage = ({
  subjectAddress,
  adjustmentSettings,
  manualAdjustmentsEntities,
  commentaryV2,
  adjustmentsTableData,
  tkv2ChartImages: { siteSizeVsCostChartImage, siteSizeVsSiteValueChartImage },
}: SiteExtractionAdjustmentsPageProps) => {
  const { title, subtitle } = COMMENTARY_TEXT['site-extraction'];

  const tableData = adjustmentsTableData.siteExtraction;

  const helperText = getCommentaryTableHelperText(
    adjustmentSettings,
    'site',
    undefined,
    manualAdjustmentsEntities,
  );

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <View style={{ paddingBottom: 8 }}>
        <Text style={fontStyles.body}>{subtitle}</Text>
        <ExportCommentaryTable
          data={tableData}
          helperText={helperText}
          configKey="siteExtraction"
        />
      </View>
      {siteSizeVsSiteValueChartImage && (
        <ExportChartContainer title="Site Size vs Site Value">
          <Image
            src={siteSizeVsSiteValueChartImage}
            style={{ height: PNG_HEIGHT, width: PNG_WIDTH }}
          />
        </ExportChartContainer>
      )}
      {siteSizeVsCostChartImage && (
        <ExportChartContainer title="Site Size vs $/SF">
          <Image src={siteSizeVsCostChartImage} style={{ height: PNG_HEIGHT, width: PNG_WIDTH }} />
        </ExportChartContainer>
      )}
      <CommentarySection
        title="Site Commentary"
        commentary={commentaryV2.siteExtraction?.commentary}
      />
    </Tkv2PDFPage>
  );
};
